<label class="ui-radio" [class.ui-radio--disabled]="disabled">
  <input
    class="ui-radio__input"
    type="radio"
    [name]="name"
    [value]="value"
    [checked]="selected === value"
    [disabled]="disabled"
    (change)="select()"
  />
  <span class="ui-radio__circle" aria-hidden="true">
    <span class="ui-radio__dot"></span>
  </span>
  <span class="ui-radio__text">
    @if (label) {
      <span class="ui-radio__label">{{ label }}</span>
    }
    @if (hint) {
      <span class="ui-radio__hint">{{ hint }}</span>
    }
  </span>
</label>
